<script setup lang="ts">
import { ISocialMediaLinks } from '@caks/shared/modules/i'
import { IconLogoDesktopWhite } from '../icon'
import { ButtonMain } from '@caks/uikit/button'
import { ChipTag } from '@caks/uikit/chip'
</script>

<template>
  <footer class="footer">
    <div class="footer__container main-container">
      <div class="footer__left">
        <div class="footer__main-data">
          <img class="footer__main-data-photo" src="/logo-white.png" alt="logo" />
          <ul class="footer__links">
            <li class="footer__links-item-link" :class="{'active': $route.name === 'About'}" @click="$router.push('/about')">
              О компании
            </li>
            <li class="footer__links-item-link" :class="{'active': $route.name === 'Contacts'}"  @click="$router.push('/contacts')">
              Контакты
            </li>
          </ul>
        </div>

        <div class="footer__separator" />

        <div class="footer__more">
          <ul class="footer__links">
            <li class="footer__li footer__li_no-underline">САК’С Сендвич Шоп</li>
            <li class="footer__li footer__li_no-underline">©{{ new Date().getFullYear() }}</li>

<!--            <li class="footer__li">Калорийность и состав</li>-->
          </ul>
        </div>
        <div class="footer__more" style="margin-top: 8px">
          <ul class="footer__links">
            <li class="footer__li">
              <a href="/Соглашение_об_оказании_услуг_вер_17_01_4.docx" target="_blank">
                Соглашение об условиях
              </a>
            </li>
            <li class="footer__li">
              <a href="/Политика ОПС_вер. 17.01.docx" target="_blank">
                Политика обработки персональных данных
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer__right">
        <a class="footer__right-phone" href="tel:88007006687">Позвонить нам</a>
        <i-social-media-links />
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.footer {
  width: 100%;
  padding: 64px 0;
  background-color: $primary-green;
  color: $white;

  &__container {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }

  &__left {
    width: 640px;
    max-width: 60%;
  }

  &__main-data {
    display: flex;
    gap: 44px;
  }

  &__links {
    display: flex;
    gap: 16px;

    &-item-link {
      @include h5-4;
      color: $white;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 24px;
      padding: 0px 12px;
      border-radius: 30px;
      @extend %hover-transition;
      white-space: nowrap;

      &.active {
        border-color: $sub-green;
        color: $primary-text;
        background-color: $sub-green;
      }

      &:hover {
        border-color: $sub-green;
        color: $primary-text;
        background-color: $sub-green;
      }
    }
  }

  &__li {
    @include h5-2;
    text-decoration: underline;
    text-decoration-color: transparent;
    transition: all 0.3s ease;
    display: flex;
    align-items: flex-end;
    cursor: pointer;
    &:hover {
      text-decoration-color: $white;
    }
    &_no-underline {
      text-decoration-color: transparent !important;
      cursor: auto;
    }
  }

  &__separator {
    height: 1px;
    margin: 32px 0;
    background-color: $ui-gray-2;
  }

  &__more {
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  }

  &__right-phone {
    @include h4-6;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    box-shadow: 0 0 5px #00000026;
    border-radius: 30px;
    min-height: 44px;
    background-color: #f5f5f8;
    border-color: #f5f5f8;
    color: #0d0802;
    transition: 0.5s;

    &:hover {
      background-color: #149446;
      border-color: #149446;
    }

  }

  &__main-data-photo {
    width: 189px;
    height: 33px;

  }
}
</style>
